// extracted by mini-css-extract-plugin
module.exports = {"channelTableContainer":"Configuration-module__channelTableContainer___3R5Os","row":"Configuration-module__row___NVuMo","spinner":"Configuration-module__spinner___1sl74"};